import React, { Component } from "react";
import { AxiosResponse } from "axios";
import { CurrentUser } from "../../../stores/CurrentUserStore/Types";
import { postRequest } from "../../../utils/httpRequest";
import { errorNotification } from "../../../utils/helpers";

interface Props {
  currentUser: CurrentUser;
  lessonId: number;
  updateComments: () => void;
}

interface State {
  content: string;
  submitting: boolean;
}

class Discussion extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      content: "",
      submitting: false,
    };
  }

  setContent = (e) => {
    this.setState({ content: e.target.value });
  };

  onSubmit = (e) => {
    e.preventDefault();

    if (!this.state.content.trim()) {
      return;
    }

    this.setState({ submitting: true });
    const { lessonId, updateComments } = this.props;

    return postRequest(`/api/comments.json?question_id=${lessonId}`, {
      content: this.state.content,
    })
      .then((response: AxiosResponse) => {
        this.setState({ content: "", submitting: false });
        updateComments();
      })
      .catch((error) => {
        this.setState({ submitting: false });

        errorNotification(
          "Error loading comments",
          JSON.stringify(error.response.data),
        );
      });
  };

  initials = () => {
    const { currentUser } = this.props;
    const name =
      currentUser?.short_name_split ||
      currentUser?.short_name ||
      currentUser?.name;

    return (
      name
        ?.split(" ")
        .map((part) => part[0])
        .join("")
        .slice(0, 2)
        .toUpperCase() || "42"
    );
  };

  render() {
    const { currentUser } = this.props;
    const { content, submitting } = this.state;

    const countryFlagImage = (countryCode) => {
      let img;
      try {
        img = require(
          `../../../../../assets/images/flags/svg/${countryCode?.toLowerCase()}.svg`,
        );
      } catch {
        img = "";
      }

      return img;
    };

    return (
      <section className="disc" aria-labelledby="discTitle">
        <h2 id="discTitle" className="discussion-target">
          Discussion
        </h2>
        <p className="disc__intro">
          Chat with other learners about this lesson.
        </p>

        <form className="disc__compose" onSubmit={this.onSubmit}>
          <span className="av-c">
            {currentUser?.profile_picture ||
            currentUser?.profile_picture_url ? (
              <img
                src={
                  currentUser.profile_picture || currentUser.profile_picture_url
                }
                alt=""
              />
            ) : (
              this.initials()
            )}
          </span>
          <div className="col">
            <div className="who">{currentUser?.short_name} (you)</div>
            <textarea
              value={content}
              rows={3}
              placeholder="Add a comment for other learners..."
              aria-label="Write a comment"
              onChange={this.setContent}
            />
            <div className="act">
              <button
                className={`btn btn-blue btn--compact ${
                  submitting ? "loading" : ""
                }`}
                type="submit"
                disabled={submitting || !content.trim()}
              >
                Post
              </button>
            </div>
          </div>
        </form>
      </section>
    );
  }
}

export default Discussion;
